import React, { useState, useEffect, useRef } from 'react';
import { withNamespaces } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import Grid from '../../../components/molecules/Grid';
import Button from '../../../components/atoms/Button';
import CarouselCard from '../../../components/molecules/CarouselCard';
import { get } from 'lodash';
import { isExperienceEditorActive } from '@sitecore-jss/sitecore-jss';
import useStyles from './style';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import Typography from '../../../components/atoms/Typography';
import Hidden from '@material-ui/core/Hidden';
import { COMPONENT_NAME } from './locators';
import { canUseDOM } from '../../../utils/canUseDOM';
import { setEqualHeight } from '../../../utils/setEqualHeight';
import { pushAnaylyticsData } from '../../../../../src/utils/analytics';
import { analyticsData } from '../../../../../src/constants/Analytics/analytics-data';
import { EVENT_TYPE, LISTING_TYPE, TAGS } from '../../../../constants/index';
import { getCardCategoryTags } from '../../../utils/getCardCategoryTags';
import { getRedirectionUrl } from '../../../utils/getRedirectionUrl';
import { getCurrentLanguage } from '../../../utils/getCurrentLanguage';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import { getPriceRange } from '../../../utils/getPriceRange';
import {
  getPageName,
  getComponentName,
} from '../../../utils/getPageComponentInfo';
import { createDynamicLabels } from '../../../../utils/analytics';
import { getItenaryItemTags } from '../../../utils/getDetailedPageTags';

const SmartList = props => {
  const {
    getSmartListStart,
    updateMultipleFiltersData,
    resetSmartList,
    contentListData,
    fields,
    sitecoreContext,
    appConfig = {},
  } = props;
  let pageContentType = get(
    sitecoreContext,
    'route.fields.contentType.fields.taxonomyKey.value',
    ''
  ).toLowerCase();
  const smartListWrapper = useRef(null);
  const classes = useStyles({ pageContentType });
  const [identifier, setIdentifier] = useState('');
  const [hasFavouriteBasket, setHasFavouriteBasket] = useState(false);
  const { title, filterType, seeMore, contentType, limit, disableSmartList } = fields;

  const vadHeader = get(sitecoreContext, 'VAAStaticRoute.sitecore.route.placeholders.vad-header', []);

  useEffect(() => {
    const favouriteBasket = vadHeader.find(item => item.componentName === 'FavoriteBasket');
    const favIsActive = get(favouriteBasket, 'fields["Is Active"].value', false);
    setHasFavouriteBasket(Boolean(favouriteBasket) && favIsActive)
  }, [vadHeader])

  const randomIntFromInterval = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
  };

  let defaultGooglePlaceId = sitecoreContext &&
    sitecoreContext.route &&
    sitecoreContext.route.fields &&
    sitecoreContext.route.fields.googlePlaceId;
  let isEditor;

  const previewMode =
    sitecoreContext &&
    sitecoreContext.pageState &&
    sitecoreContext.pageState.toLowerCase();

  if (isExperienceEditorActive() || previewMode === 'preview') {
    isEditor = true;
  } else {
    isEditor = false;
  }

  useEffect(() => {
    if (sitecoreContext.language && fields && (disableSmartList && !disableSmartList.value)) {
      const uid = `smartList${randomIntFromInterval(100, 10000)}`;
      resetSmartList && resetSmartList();
      const queryObject = () => {
        const filterArray =
          filterType &&
          filterType.length > 0 &&
          filterType.map(filter => {
            return {
              key: get(filter, 'fields.taxonomyKey.value', ''),
              value: get(filter, 'fields.searchKey.value', ''),
            };
          });

        if (category) {
          filterArray &&
            filterArray.push({
              key: get(category, 'taxonomyKey.value', ''),
              value: get(category, 'searchKey.value', ''),
            });
        }
        return {
          contentType: get(contentType, 'fields.taxonomyKey.value', ''),
          language: sitecoreContext && sitecoreContext.language,
          facetFields: [],
          limit: parseInt(get(limit, 'value', '')),
          offset: 0,
          filters: filterArray,
          isPreviewMode: isEditor,
        };
      };
      getSmartListStart(queryObject(), uid);
      setIdentifier(uid);
    }
  }, [sitecoreContext.language]);

  useEffect(() => {
    if (canUseDOM) {
      const seeAllBtn = document.querySelectorAll('.seeAllBtn');
      seeAllBtn &&
        seeAllBtn.forEach(btn =>
          btn.addEventListener('click', () => {
            window.scroll({
              top: '0',
              left: '0',
              behavior: 'smooth',
            });
          })
        );

      // Make sure address aligns with it self throughtout cards.
      setEqualHeight(smartListWrapper.current, '.bot-area');
    }
  });
  useEffect(() => {
    if (canUseDOM) {
      window.addEventListener('resize', () => {
        // Make sure address aligns with it self throughtout cards.
        setEqualHeight(smartListWrapper.current, '.bot-area');
      });
    }
  }, []);

  if (!fields) {
    return null;
  }
  const category = get(sitecoreContext, 'route.fields.category.fields', '');
  let cardKeys = getDictionaryText(pageContentType).split(',');

  const ratingOutOf = getDictionaryText('outOf5');
  const language = getCurrentLanguage({ sitecoreContext });

  const addAnalyticsInfo = () => {
    const obj = {
      ...get(analyticsData, 'pageBodyInteraction.arrowClick'),
      ...{
        label: createDynamicLabels([
          getPageName(props),
          getComponentName(props),
          `${title && title.value} - ${get(seeMore, 'value.text')}`,
        ]),
      },
    };
    pushAnaylyticsData(obj);
  };

  const consolidateData =
    contentListData &&
    contentListData.data.filter(function (data) {
      return data.id === identifier;
    });
  const data = get(consolidateData[0], 'data.data.results', '');
  const totalResults = get(consolidateData[0], 'data.data.totalResults', '');
  const showViewAll = data && totalResults
    ? parseInt(totalResults) > parseInt(get(limit, 'value', ''))
    : false;
  const getResults = () => {
    addAnalyticsInfo();
    const filterArray =
      filterType &&
      filterType.length > 0 &&
      filterType.map(filter => {
        return {
          key: get(filter, 'fields.taxonomyKey.value', ''),
          value: get(filter, 'fields.searchKey.value', ''),
        };
      });
    updateMultipleFiltersData(filterArray);
  };

  const getAdditionalCardAttributes = item => {
    let other = {};
    let featuredEvent;
    if (pageContentType === EVENT_TYPE) {
      if (item.isFeatured) {
        featuredEvent = getDictionaryText('featuredText') || '';
      }
      other = {
        startDate: item.startDate,
        endDate: item.endDate,
        openTime: item.openTime,
        closeTime: item.closeTime,
        umbrellaEventCount: item.umbrellaEventCount,
        isEventListing: true,
        peopleInterested:
          item.interestedCount &&
          `${item.interestedCount} ${getDictionaryText('interestedText')}`,
        eventType: {
          featured: featuredEvent,
          isPaid: item.eventType,
        },
        locationTitle:
          get(item, 'location_Titles.length') > 0 && item.location_Titles[0],
        region:
          get(item, 'location_Regions.length') > 0 && item.location_Regions[0],
        language,
        urlSlug: item.urlSlug,
        eventCategories: item.eventCategories
      };
    }
    return other;
  };

  let tags;
  if (totalResults > 0) {
    return (
      <div
        className={`${classes.root} smart-list-wrapper`}
        data-locator={COMPONENT_NAME}
        ref={smartListWrapper}
      >
        <Grid container classes={{ root: classes.bottomSpacing }}>
          {totalResults > 0 && (
            <Grid item xs={12} lg={8}>
              <Typography variant="h5Bold" component="h2">
                {title && <Text field={title} />}
              </Typography>
            </Grid>
          )}
          {showViewAll && get(seeMore, 'value.text') && (
            <Grid item lg={4} classes={{ root: classes.alignRight }}>
              <Button
                component="span"
                buttonType="primary"
                hasBorder={false}
                size="small"
                onClick={getResults}
                className="seeAllBtn"
              >
                {get(seeMore, 'value.text', '')}
              </Button>
            </Grid>
          )}
        </Grid>
        <Grid container classes={{ root: classes.spacing }}>
          {data &&
            data.map((item, i) => {
              // This function will return category tags associated with corresponding page
              tags = getCardCategoryTags(
                item,
                getDictionaryText(`${pageContentType}${TAGS}`)
              );

              if (item.suitableForTags && tags.length < 1) {
                tags = item.suitableForTags
              }
              if (tags.length < 1) {
                tags = getItenaryItemTags(item)
              }
              tags = tags.filter(tag => tag);

              let priceTagData = getPriceRange(item.priceTags);

              let dymnamicProps = [];
              if (cardKeys && cardKeys.length > 0) {
                cardKeys.forEach(key => {
                  dymnamicProps[key] = get(item, key, '');
                });
              }
              const thumbnailSrc = {
                src: get(item, 'thumbnailImage', ''),
                alt: get(item, 'name', ''),
                '3x2-card': {
                  'large': get(item, 'thumbnailImage', ''),
                },
              };
              const thumbnailImage = {
                value:
                  pageContentType === EVENT_TYPE
                    ? thumbnailSrc
                    : get(item, 'thumbnailImage', ''),
              };
              return (
                <Grid item lg={4} key={i}>
                  <CarouselCard
                    title={get(item, 'name', '')}
                    desktopImage={thumbnailImage}
                    mobileImage={thumbnailImage}
                    aspectRatioNeeded={contentType !== EVENT_TYPE}
                    imageCtaUrl={
                      pageContentType === EVENT_TYPE
                        ? getRedirectionUrl(item, language)
                        : get(item, 'itemUrl', '')
                    }
                    ctaLink={tags}
                    cardType={
                      pageContentType === EVENT_TYPE ? EVENT_TYPE : LISTING_TYPE
                    }
                    ratingOutOf={ratingOutOf}
                    sectionTitle={title}
                    pageName={getPageName(props)}
                    componentName={getComponentName(props)}
                    {...dymnamicProps}
                    {...getAdditionalCardAttributes(item)}
                    expenseRange={priceTagData}
                    viewsCount={get(item, 'viewsCount', '')}
                    num_reviews={get(item, 'tripAdvisorNumberOfReviews', '')}
                    rating_image_url={get(item, 'tripAdvisorRatingImageURL', '')}
                    googlePlaceId={get(item, 'googlePlaceId', '')}
                    itemUniqueKey={get(item, 'itemUniqueKey', '')}
                    defaultGooglePlaceId={defaultGooglePlaceId}
                    language={language}
                    googlePlacesAPI={appConfig.GOOGLE_PLACES_API}
                    showFavoriteIcon={hasFavouriteBasket}
                  />
                </Grid>
              );
            })}
        </Grid>
        {showViewAll && get(seeMore, 'value.text') && (
          <Hidden lgUp implementation="css">
            <Button
              buttonType="primary"
              hasBorder={false}
              size="small"
              onClick={getResults}
              className="seeAllBtn"
            >
              {get(seeMore, 'value.text', '')}
            </Button>
          </Hidden>
        )}
      </div>
    );
  } else {
    return '';
  }
};

export default withSitecoreContext()(withNamespaces()(SmartList));

export { SmartList };
